import React,{ Component } from 'react';
import { Col, Row } from 'reactstrap';
import { css } from 'aphrodite/no-important';
import { Link } from 'react-router-dom';
import { panelStyles } from './styles';
import * as Icon from 'react-feather';

export default class Panel extends Component{
    render(){
        const { title, total, color, icon, link = "" } = this.props;
        const { item, panelTitle, number } = panelStyles;
        const PanelIcon = Icon[icon];
        return (
            <Col lg sm="5" style={{backgroundColor: color}} className={`rounded ${css(item)}`}>
                <Row>
                    <Col xs="5" md="4"><PanelIcon style={{color: "#fff"}} size={45}/></Col>
                    <Col xs="7" md="8" className="text-right">
                        <Link to={link}><div className={css(number)}><strong>{ total }</strong></div></Link>
                        <div className={css(panelTitle)}><span>{ title }</span></div>
                    </Col>
                </Row>
            </Col>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/App/Layout/Panel.js